<template>
  <div>
    <div
      v-if="purchaseList.length>0"
      class="search-shopping"
      v-show="!searchBoxShow"
    >
      <div
        class="search-shopping-arrow"
        @click="searchBoxShow=true"
      >
        <div style="float:left;padding-right:3px;">
          <div style="margin-top:3px">
            <img
              src="@/assets/icon/arrow-left.png"
              width="16"
            />
          </div>
        </div>
        <div style="float:left">
          <span class="text-white">{{purchaseList.length>99? '99+': purchaseList.length}}</span>
        </div>
        <div style="clear:both"></div>
      </div>
    </div>

    <transition name="fade">
      <div
        class="search-shopping-open"
        v-show="searchBoxShow"
      >
        <div
          class="search-shopping-arrow search-icon-close"
          @click="searchBoxShow=false"
        >
          <div style="float:left;padding-right:3px;">
            <div style="margin-top:3px">
              <img
                src="@/assets/icon/arrow-right.png"
                width="16"
              />
            </div>
          </div>
          <div style="float: left;">
            <span class="text-white">{{purchaseList.length>99? '99+': purchaseList.length}}</span>
          </div>
          <div style="clear:both"></div>
        </div>

        <div class="search-shopping-citys">

          <p
            v-for="(city,i) in groupByCity"
            :key="i"
          >
            <ButtonGroup
              size="small"
              class="m-t-2"
            >
              <Button
                :type="chooseGroupCity===city?'warning':'default'"
                icon="md-close"
                @click="handleDeleteCity(city)"
              ></Button>
              <Button
                :type="chooseGroupCity===city?'warning':'default'"
                @click="handleGroupCity(city)"
              >{{city}}</Button>
            </ButtonGroup>
          </p>

        </div>
        <div class="search-shoping-purchase">
          <div
            v-for="(item,i) in showPurchaseList"
            :key="i"
            :style="(i+1)%2===0?'background-color:#f8f8f9':''"
          >
            <Row
              :gutter="8"
              class="p-t-5 p-b-5 p-l-10 p-r-10"
            >
              <i-col span="20">
                <div>{{item.stationName}} <span class="remark">{{item.rank}}%</span> </div>
                <div style="color:#8f8f8f;font-size:12px;">{{item.assetName}}</div>
              </i-col>
              <i-col
                span="4"
                class="text-center"
              >
                <a
                  class="text-red"
                  @click="handleRemovePurchase(item)"
                >
                  <Icon type="md-close" />
                </a>
              </i-col>
            </Row>
          </div>
        </div>

        <div class="search-shopping-review">
          <Button
            type="warning"
            long
            size="large"
            :disabled="purchaseList.length===0"
            @click="handleReview"
          >详情预览</Button>
        </div>
      </div>
    </transition>

    <Modal
      class="modal-no-mask"
      v-model="modalConfirm"
      width="500"
      :closable="false"
      :mask-closable="false"
      :mask="false"
      :transfer="false"
      footer-hide
      :styles="{top: '35%'}"
    >
      <p class="text-center text-16 text-black">数据很多，任君选择</p>
      <Row class="text-center m-t-10">
        <i-col span="16">
          <p class="text-left text-black-8f">站点输出数据百分比</p>
          <Slider
            v-model="reviewPageSize"
            :step="5"
            :min="5"
            :max="100"
            :tip-format="formatReviewSize"
            @on-input="handleChangePageSize"
          ></Slider>
        </i-col>
        <i-col span="8">
          <p class="text-black-8f">预估报表生成页数</p>
          <p class="m-t-5 text-black">{{outputPage}}页</p>
        </i-col>
      </Row>

      <Row class="text-center m-t-10">
        <i-col span="24">
          <Button
            size="small"
            class="m-r-10"
            style="width:80px"
            @click="modalConfirm=false"
          >取消</Button>
          <Button
            type="warning"
            size="small"
            style="width:80px"
            @click="handleSubmit"
          >确认</Button>
        </i-col>
      </Row>

      <Spin
        v-if="loading"
        fix
        size="large"
      >
        <Icon
          type="ios-loading"
          size=18
          class="spin-icon-load"
        ></Icon>
        <div>数据生成中，您可能需要等待10秒~2分钟</div>
      </Spin>
    </Modal>
  </div>
</template>

<script>
import axios from 'axios'
import { deleteStation, getPreOrderId } from '@/api/search'

export default {
  data () {
    return ({
      searchBoxShow: false,
      chooseGroupCity: '', // 当前选中的城市分组
      showPurchaseList: [], // 需要显示的采购清单

      loading: false,
      modalConfirm: false,
      reviewPageSize: 30,
      outputPage: '',
      ratioRate: 0 // 数据全量输出的PDF页面大小
    })
  },
  mounted () {
    this.loadPurchaseListByGroup()
  },
  methods: {
    handleRemovePurchase (item) {
      let updateBean = {
        type: 'remove',
        item: item
      }
      this.$store.commit('set_search_updatePurchase', updateBean)
    },
    handleReview () {
      this.modalConfirm = true
      this.loading = false

      let postData = Object.assign({}, this.defaultSearchCondition, { orderId: this.preOrderId })
      axios.post(process.env.API_URL + '/ooh-search/v1/pdf/getpdfpredictpage',
        postData,
        {
          headers: { 'Content-Type': 'application/json' },
          withCredentials: false
        }
      ).then(res => {
        this.ratioBean = res.data.pageSize / res.data.ratio
        this.handleChangePageSize(this.reviewPageSize)
      })
    },
    formatReviewSize (val) {
      return '' + val + '%'
    },
    handleChangePageSize (value) {
      let outPage = parseInt(this.ratioBean * value)

      this.outputPage = outPage < 1 ? 1 : outPage
    },
    handleSubmit () {
      this.loading = true
      let postData = Object.assign({}, this.defaultSearchCondition,
        {
          orderId: this.preOrderId,
          ratio: this.reviewPageSize
        }
      )

      axios.post(process.env.API_URL + '/ooh-search/v1/order/submit',
        postData,
        {
          headers: { 'Content-Type': 'application/json' },
          withCredentials: false
        }
      ).then(res => {
        if (res.data.errcode) {
          this.$Notice.warning({
            title: '操作提示！',
            desc: res.data.errmsg
          })
        } else {
          this.$router.push({ path: '/review/' + this.preOrderId })
        }
        this.loading = false
        this.modalConfirm = false
      })
    },
    handleGroupCity (cityName) {
      if (cityName === this.chooseGroupCity) {
        this.chooseGroupCity = ''
      } else {
        this.chooseGroupCity = cityName
      }
      this.loadPurchaseListByGroup()
    },
    handleDeleteCity (cityName) {
      let postData = {
        orderId: this.preOrderId,
        stationIds: JSON.stringify(this.purchaseList.filter(x => x.cityName === cityName).map(x => x.stationId))
      }

      deleteStation(postData).then(() => {
        this.$store.commit('set_search_purchaseList', this.purchaseList.filter(x => x.cityName !== cityName))
        this.loadPurchaseListByGroup()
      })
    },
    loadPurchaseListByGroup () {
      if (this.chooseGroupCity !== '') {
        this.showPurchaseList = this.purchaseList.filter(x => x.cityName === this.chooseGroupCity).sort((a, b) => {
          return a.stationName.localeCompare(b.stationName)
        })

        // 当前分组内无数据， 可能来自删除
        if (this.showPurchaseList.length === 0) {
          this.chooseGroupCity = ''
          this.loadPurchaseListByGroup()
        }
      } else {
        this.showPurchaseList = this.purchaseList.sort((a, b) => {
          return a.stationName.localeCompare(b.stationName)
        })
      }
    },
    handleUpdatePurchase () { // 更新或者删除关注清单
      if (this.updatePurchase.type === 'add') {
        if (!this.preOrderId || this.preOrderId === 0) { // 先创建查询订单
          getPreOrderId().then(preOrderId => {
            this.$store.commit('set_search_preOrderId', preOrderId)
            // 开始执行添加点位操作
            let addOrderStationDTO = Object.assign({}, this.searchConditionDTO, { orderId: this.preOrderId, stationId: this.updatePurchase.item.stationId })
            axios.post(process.env.API_URL + '/ooh-search/v1/purchase/addstation',
              addOrderStationDTO,
              {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: false
              }
            )
          })
        } else {
          // 开始执行添加点位操作
          let addOrderStationDTO = Object.assign({}, this.searchConditionDTO, { orderId: this.preOrderId, stationId: this.updatePurchase.item.stationId })
          axios.post(process.env.API_URL + '/ooh-search/v1/purchase/addstation',
            addOrderStationDTO,
            {
              headers: { 'Content-Type': 'application/json' },
              withCredentials: false
            }
          )
        }

        let newPurchaseList = this.purchaseList.concat([this.updatePurchase.item])
        this.$store.commit('set_search_purchaseList', newPurchaseList)
        this.loadPurchaseListByGroup()
      } else {
        // 删除关注清单
        let index = this.purchaseList.findIndex(x => x.stationId === this.updatePurchase.item.stationId)
        this.purchaseList.splice(index, 1)
        if (this.purchaseList.length === 0) {
          this.searchBoxShow = false
        }

        let postData = {
          orderId: this.preOrderId,
          stationIds: JSON.stringify([this.updatePurchase.item.stationId])
        }

        deleteStation(postData).then(() => {
          this.$store.commit('set_search_purchaseList', this.purchaseList)
          this.loadPurchaseListByGroup()
        })
      }
    }
  },
  computed: {
    defaultSearchCondition () {
      return this.$store.state.search.searchCondition
    },
    purchaseList () {
      return this.$store.state.search.purchaseList
    },
    groupByCity () {
      let cityGroup = []
      this.purchaseList.forEach(element => {
        if (!cityGroup.includes(element.cityName)) {
          cityGroup.push(element.cityName)
        }
      })

      return cityGroup.sort((a, b) => {
        return a.localeCompare(b)
      })
    },
    preOrderId () {
      return this.$store.state.search.preOrderId
    },
    updatePurchase () {
      return this.$store.state.search.updatePurchase
    },
    searchConditionDTO () {
      return this.$store.state.search.searchCondition
    },
    showPurchase () {
      return this.$store.state.search.showPurchase
    }
  },
  watch: {
    updatePurchase () {
      this.handleUpdatePurchase()
    },
    showPurchase (val) {
      this.searchBoxShow = true
    }
  }
}
</script>
